"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfiguration = void 0;
exports.defaultConfiguration = {
    html_input: 'ALLOW',
    headerIds: false,
};
//# sourceMappingURL=markdown.js.map